import React from 'react';
import { CTABand } from '../../components/CTABand';
export function KidsTaekwondoFinalCTA() {
  return <CTABand headline="Ready to Find the Right Kids Class?" copy="Storm Taekwondo helps kids build confidence, focus and real martial arts skills. Talk to us to choose the best starting class for your child." data-id="element-2196" />;
}